import { useModelContext } from '@app/contexts/model';
import { useStorageTranslateContext } from '@app/modules/Translate/contexts/storage';
import { setRowVisible } from '@app/modules/Translate/factory/setRowVisible';
import { Button, ButtonGroup, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FunctionComponent, useMemo } from 'react';
interface TranslateCategoryProps {}

export const TranslateCategory: FunctionComponent<TranslateCategoryProps> = observer((props: TranslateCategoryProps) => {
    const { translateStore } = useStorageTranslateContext();
    const { languageFileModel } = useModelContext();

    const list = useMemo(() => {
        const sortedCategories = Array.from(translateStore.categoryData).sort((a, b) => {
            return a.value.localeCompare(b.value);
        });
        return new Map(
            sortedCategories.map((item) => {
                return [item.value, item];
            })
        );
    }, [translateStore.categoryData.length]);

    let dataLanguageResponse = languageFileModel.dataLanguage.get();
    let emptyCategories = translateStore.categoryData.length > 0;

    return dataLanguageResponse && translateStore.categoryOpen ? (
        <Stack spacing={2}>
            <Typography variant={'subtitle1'}>Categories:</Typography>
            {emptyCategories && (
                <ButtonGroup
                    sx={{
                        maxHeight: 'calc(100% - 26px)',
                        overflowY: 'auto'
                    }}
                    size={'small'}
                    orientation='vertical'
                    variant='text'
                    aria-label='Basic button group'>
                    {Array.from(list.values()).map((item) => {
                        return (
                            <Button
                                sx={{
                                    paddingY: '2px',
                                    width: '202px',
                                    wordBreak: 'break-word',
                                    justifyContent: 'flex-start',
                                    textAlign: 'left'
                                }}
                                key={item.key}
                                role={undefined}
                                onClick={() => {
                                    setRowVisible(translateStore.gridApi, item.key);
                                }}>
                                {item.value}
                            </Button>
                        );
                    })}
                </ButtonGroup>
            )}
        </Stack>
    ) : (
        <></>
    );
});
